<template>
  <section class="social-responsibility">
    <Slogn title1="共富精神" title2="誠信商品.社會貢獻" sub-title="Join Hands to Create the Future." />
    <MarkComponent class="section section1">
      <p class="title">共富精神</p>
      <p class="sub-title">脫離貧窮，創造機會這是希望聯盟的責任。</p>
      <p class="content"> 希望聯盟透過公平、公開的讓利制度，讓在平台消費之每一個會員都能夠共同共享消費紅利。一別以往之合作社企業，只靠下線增加收入，我們提供所有人相同機會的發展舞台，讓每一位希望聯盟會員在消費的同時，也能創造收益，逐步讓會員在消費的同時脫離貧窮、創造機會，共享富裕人生。 </p>
    </MarkComponent>
    <MarkComponent class="section section2">
      <p class="title">誠信商品</p>
      <p class="content">
        消費者滿意是希望聯盟的基本信念，唯有提供消費者滿意的商品，才能讓希望聯盟成為受消費者喜愛的購物平台，逐漸養成消費者的購買習慣，讓希望聯盟長久經營下去
        <br>
        希望聯盟將嚴格遵守政府相關規定，只提供各項高品質及符合各項檢驗的商品，保證在本網站購買之任何產品都是優質、合規、合法的正品，讓消費者買的安心，用得開心。
      </p>
    </MarkComponent>
    <MarkComponent class="section section3">
      <p class="title">社會貢獻</p>
      <p class="content">
        希望聯盟取之於社會，用之於社會，透過提供超越顧客與社會期待的優質商品、服務...等的企業活動，努力並持續地對社會做出貢獻
        <br>
        此外，作為一位企業公民，希望聯盟深知必須善盡對社會的責任、未來並積極參與社會公益的活動，期許每位希望聯盟夥伴，除了理解希望聯盟對社會貢獻的想法之外，也能扮演好社會中所被期待的角色
      </p>
    </MarkComponent>
  </section>
</template>
<script>
import Slogn from '@/components/Slogn'
import MarkComponent from '@/components/MarkComponent.vue'

export default {
  components: {
    Slogn,
    MarkComponent
  }
}
</script>
<style scoped lang="scss">
.social-responsibility {
  position: relative;
}
.section {
  margin-top: 40px;
  @include minWidth992 {
    width: calc(100% - 300px);
  }
}
.section2 {
  @include minWidth992 {
    left: 150px;
  }
}
.section3 {
  @include minWidth992 {
    left: 300px;
  }
}
.title {
  font-size: 22px;
  color: $mainPurple;
  line-height: 1;
  margin: 0;
}

.sub-title {
  font-size: 18px;
  color: $black;
}

.content {
  color: $deepGrey;
  font-size: 16px;
  margin: 12px 0 0;
}

</style>
